import { z } from 'zod';
import { defineEndpoint } from '../define';
import { UserAppleUdidSchema } from './shapes';

// Self-service read: the caller's own Apple UDIDs. Auth-only — no permission
// key, so anyone can manage the devices they want ad hoc builds on.
export const getMyAppleUdids = defineEndpoint({
  method: 'GET',
  path: '/v1/apple-udids/mine',
  params: z.object({}),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: z.array(UserAppleUdidSchema) }),
});
